<template>
    <div class="padding">
        <Loader v-show="loading"></Loader>
        <ProjectsTable @change="requestData" :data="items"></ProjectsTable>
    </div>
</template>

<script>
    import {
        Api
    } from '../../../services';
    import queryString from 'query-string';
    import Loader from '../Components/Loader.vue';
    import ProjectsTable from './ProjectsTable.vue'
    export default {
        name: 'Projects',
        data() {
            return {
                msg: 'Pleaase wait ...',
                subdomain: 'hat',
                client_id: '-PsAjA85atcU6QvOwHP2qA',
                redirect_uri: 'http://localhost:8080',
                items: [],
                loading: true
            }
        },
        components: {
            Loader,
            ProjectsTable
        },
        created() {
        },
        methods: {
            auth() {},
            requestData(params) {
                this.loading = true;
                Api
                    .Projects()
                    .list(params)
                    .then((res) => this.items = res.data)
                    .then(() => this.loading = false)
                    .catch(err => {
                        console.log('error:', err);
                        return this.loading = false;
                    })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Admin/Projects/Projects.vue